var map = {
	"./de.js": [
		4340,
		340
	],
	"./en.js": [
		8709,
		709
	],
	"./esp.js": [
		285,
		285
	],
	"./hun.js": [
		3483,
		483
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 4615;
module.exports = webpackAsyncContext;